import { FC, PropsWithChildren } from 'react'
import Icon, { IconName } from './Icon/Icon'

type Props = {
	iconName: IconName
	onClick(): void
}

const MenuItem: FC<PropsWithChildren<Props>> = props => {
	const { iconName, onClick, children } = props
	return (
		<div className="menu__item" onClick={onClick}>
			<div className="menu__item-icon">
				<Icon iconName={iconName} />
			</div>
			<div className="menu__item-label">{children}</div>
		</div>
	)
}

export default MenuItem
